
import { useEffect } from 'react'
import SectionAPI from '../../../api/SectionAPI'
import ZoneAPI from '../../../api/ZoneAPI'
import Layout from '../../../components/Layout'
import PagedView from '../../../components/PagedView'
import { setZone } from '../../../store'
import { connect } from 'react-redux'

const CitySectionPage = (props) => { 
    useEffect(() => console.log(props), [])

    const handlePageChange = (pageNumber) => {
        const currentAddr = document.location.href;
        console.log(currentAddr);
    }

    return <Layout overrideStyle={{backgroundColor: "white"}} style={{backgroundColor: 'white'}} title={`ETA - Guides for black millenial events in ${props.zone.name}`}
            description={`Find the dopest things to do, from day parties to art shows in ${props.zone.name}, curated for black millennials and those that love the culture.`}>
        <div style={{marginTop: 50}}>
        <h2 style={{marginBottom: 20}}>Guides in {props.zone.name}</h2>
        <PagedView count={props.sections.count} 
        onPageChanged={(number) => handlePageChange(number)}>
            {props.sections && props.sections.results.map((item, index) => 
            <div style={{width: '50%', marginBottom: 20}}>
            <p style={{marginBottom: 0}}><a href={`/section/${item.id}?zone=${props.city}`}>{item.title}</a></p>
            <p style={{marginTop: 0}}>{item.description}</p>
            </div>)}
        </PagedView>
    </div> 
    </Layout>
}

CitySectionPage.getInitialProps = async (ctx: any) => { 
    const sectionApi = new SectionAPI();
    const zoneApi = new ZoneAPI();
    const city = ctx.query.city;
    var page = ctx.query.page;
    if (!page) { 
        page = 1;
    }
    var zone = null;
    const zoneResp = await zoneApi.getZone(city);
    if (zoneResp && zoneResp.code !== -1) {
        zone = zoneResp
    } 
    if (!zone) { 
        ctx.res.redirect("/404")
    }
    const citySections = await sectionApi.getSections(city, null, "manual", "tags", page);
    var sections = null
    if (citySections.code !== -1 && citySections) {
        sections = citySections
    }
    return {city: city, sections: sections, zone: zone}
}

export default CitySectionPage;